export default {
  setActiveMessage(state, payload) {
    state.activeMessageId = payload;
  },
  toggleHistoryShown(state) {
    state.isHistoryShown = !state.isHistoryShown;
  },
  hideHistory(state) {
    state.isHistoryShown = false;
  },
};
